'use strict';

const ajax = require('./modules/ajax'),
    login = require('./login'),
    scrollHelper = require('./modules/helpers/scroll'),
    isMobile = require('./modules/util/isMobile'),
    toaster = require('./toaster');

const loginOverlay = {
    init: function () {
        if (!isMobile()) {
            return;
        }

        $(document).on('click', '.js-trigger-overlay-login', function (e) {
            e.preventDefault();
            e.stopPropagation();
            initLoadingLoginForm(false);
        });

        $(document).on('click', '.js-trigger-overlay-gwp-login', function (e) {
            e.preventDefault();
            e.stopPropagation();
            initLoadingLoginForm(true, $(this).data('gwpsource'));
        });

        $(document).on('click', '.js-hide-overlay', function (e) {
            e.preventDefault();
            e.stopPropagation();
            login.hideOverlay();
        });
    }
};

const initLoadingLoginForm = function(showGwpWelcomeMessage, gwpsource) {
    toaster.closeToasters();

    const container = $('.js-login-overlay');
    ajax.load({
        skipDataType:true,
        data: {
            showGwpWelcomeMessage: showGwpWelcomeMessage,
            gwpsource: gwpsource,
            isLoginFormOnMobile: true
        },
        url: Urls.getLoginPage,
        target:container,
        handleJson: function (response) {
            if (response.alreadyLoggedIn) {
                //TODO: handle already logged in customer
                return;
            }
        },
        callback: function (response) { /* eslint-disable-line */
            container.addClass('overlay-visible').animate({
                bottom: 0
            }, 800,
            function(){
                login.init();
                scrollHelper.disableScroll();
                container.find('.js-loginwrap .inputfield-text').first().focus();
            });
        }
    });
};


module.exports = loginOverlay;
